export enum ReccurenceStateEnum {
  Loading = 0,
  Form = 1,
  View = 2,
  Paused = 3,
}